import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import SplitDialog from '@rio-cloud/rio-uikit/SplitDialog';

import { useIsServiceInfoDialogShown, useServiceInfoDialogChapter } from './serviceInfoSelectors';
import { Pages } from './pages/Pages';
import { serviceInfoDialogClosed, serviceInfoDialogOpenedAtChapter } from './serviceInfoSlice';
import { ServiceInfoDialogMenu } from './ServiceInfoDialogMenu';
import type { ServiceInfoChapter } from './chapters';
import { config } from '../../config';
import { hasServiceInfoSearchParamsState, useServiceInfoSearchParams } from './serviceInfoSearchParams';

export const ServiceInfoDialog = () => {
    const dispatch = useDispatch();
    const { searchParams, showServiceInfo, hideServiceInfo } = useServiceInfoSearchParams();

    const show = useIsServiceInfoDialogShown();
    const chapter = useServiceInfoDialogChapter();
    const applicationName = config.applicationName;

    useEffect(() => {
        if (show && !hasServiceInfoSearchParamsState(searchParams, chapter)) {
            showServiceInfo(chapter);
        }
    }, [chapter, searchParams, show, showServiceInfo]);

    const handleServiceInfoDialogClosed = () => {
        dispatch(serviceInfoDialogClosed());
        hideServiceInfo();
    };

    const handleSelectChapter = (event: React.MouseEvent<HTMLSpanElement>) => {
        event.preventDefault();
        const chapter = event.currentTarget.getAttribute('data-name');
        if (chapter) {
            const serviceInfoChapter = chapter as ServiceInfoChapter;

            dispatch(serviceInfoDialogOpenedAtChapter(serviceInfoChapter));
            showServiceInfo(serviceInfoChapter);
        }
    };

    return (
        <SplitDialog
            show={show}
            title={applicationName}
            bsSize={Dialog.SIZE_LG}
            leftContent={<ServiceInfoDialogMenu chapter={chapter} onSelectChapter={handleSelectChapter} />}
            rightContent={<Pages page={chapter} />}
            rightContentClassName='padding-0'
            onClose={handleServiceInfoDialogClosed}
        />
    );
};
